import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { Degree } from '@/models/Degree';
import { ISeoMetaDataInfo } from '../ISeoMetaDataInfo';
import { DeliveryMethodEnum } from '@studyportals/search-api-interface';
import { SeoMetaDataHandlerDefaultSort } from '../SeoMetaDataHandlerDefaultSort';

export class Attendance extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState)) &&
			(await this.selectionOnlyFor([FilterKey.DELIVERY_METHOD], filterSelectionState))
		);
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const attendanceValue = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);

		if (attendanceValue === DeliveryMethodEnum.ONLINE) {
			return Promise.resolve(this.constructSeoInfoForOnline(degree));
		}

		return Promise.resolve(this.constructSeoInfoForOtherThanOnline(degree, filterSelectionState));
	}

	private constructSeoInfoForOnline(degree: Degree): ISeoMetaDataInfo {
		const portalName = degree.toPortalName();

		return {
			title: `Study online: Complete list of online universities | ${portalName}`,
			description:
				`Looking to study online? ` +
				`Browse our complete list of universities offering online studies. ` +
				`Filter by country or state to find the best option for you.`,
		};
	}

	private constructSeoInfoForOtherThanOnline(
		degree: Degree,
		filterSelectionState: FilterSelectionState
	): ISeoMetaDataInfo {
		const attendance = this.constructAttendanceDisplayName(filterSelectionState);
		const portalName = degree.toPortalName();

		return {
			title: `Complete list of ${attendance} universities | ${portalName}`,
			description:
				`Looking to study ${attendance}? ` +
				`Browse our complete list of universities offering ${attendance} studies. ` +
				`Filter by country or state to find the best option for you.`,
		};
	}

	private constructAttendanceDisplayName(filterSelectionState: FilterSelectionState): string {
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ?? '';
		return attendance === AttendanceFilterOptionValue.FACE_2_FACE ? 'on campus' : attendance;
	}
}
